var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Error_Default_DarkPink70_16x16",
    "data-name": "Icon Error Default DarkPink70% 16x16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27992",
    "data-name": "Rectangle 27992",
    width: 16,
    height: 16,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "paths",
    transform: "translate(0.678 1.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30251",
    "data-name": "Group 30251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50417",
    "data-name": "Path 50417",
    d: "M9.355,5.036l5.533,10H3.855l5.5-10M2.121,15.369a.667.667,0,0,0,.567,1H16.021a.667.667,0,0,0,.567-1l-6.667-12a.667.667,0,0,0-1.133,0Z",
    transform: "translate(-2.032 -3.054)",
    fill: "#aa384b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50418",
    "data-name": "Path 50418",
    d: "M22,17.667v3a.667.667,0,0,0,1.333,0v-3a.667.667,0,0,0-1.333,0Z",
    transform: "translate(-15.344 -12.351)",
    fill: "#aa384b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 0.667,
    cy: 0.667,
    r: 0.667,
    transform: "translate(6.656 9.649)",
    fill: "#aa384b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.969d4af0600b0606be395168800a464d.svg";
export { ForwardRef as ReactComponent };